import { ErrorTracking } from '@posthog/core';

import { posthog } from '@/instrumentation-client';

import { parseLogLevel } from '../config';

import type { LogLevel, LoggerPlugin, LogEntry } from '../types';

export const POSTHOG_MIN_LEVEL: LogLevel = parseLogLevel(
  process.env.NEXT_PUBLIC_LOG_LEVEL_POSTHOG,
  'error',
);

const stackParser = ErrorTracking.createDefaultStackParser();

export const PostHogPlugin: LoggerPlugin = {
  name: 'posthog',
  minLevel: POSTHOG_MIN_LEVEL,

  handle(entry: LogEntry) {
    if (typeof window === 'undefined') return;
    if (!posthog.__loaded) return;
    if (posthog.has_opted_out_capturing()) return;

    const { level, message, context, traceId, tags } = entry;
    const { stack, source, ...rest } = context ?? {};

    const exceptionEntry: ErrorTracking.Exception = {
      type:
        typeof source === 'string'
          ? source
          : level === 'error'
            ? 'Error'
            : 'Warning',
      value: message,
      mechanism: { type: 'generic', handled: true },
    };

    if (typeof stack === 'string' && stack) {
      exceptionEntry.stacktrace = { type: 'raw', frames: stackParser(stack) };
    }

    posthog.capture('$exception', {
      $exception_list: [exceptionEntry],
      $exception_level: level === 'warn' ? 'warning' : 'error',
      ...(traceId ? { trace_id: traceId } : {}),
      ...(tags?.length ? { tags: tags.join(',') } : {}),
      ...rest,
    });
  },
};
